<template>
  <div>
    <table class="table table-borderless table-align table-h51">
      <thead>
        <tr>
          <th>
            <BkpsCheckBox :value="checkAllRow" @input="$emit('changeCheckAllRow', $event)"/>
          </th>
          <th>ID do evento de agendamento</th>
          <th>ID do agendamento</th>
          <th>ID da conta</th>
          <th>Nome da conta</th>
          <th>App</th>
          <th>Data de criação</th>
          <th>Data de atualização</th>
          <th>Agendado para</th>
          <th>Executado em</th>
          <th>Ativo</th>
          <th>Cor</th>
          <th>Criado por</th>
          <th>Atualizado por</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="eventSchedule in eventSchedules" :key="eventSchedule.id">
          <td>
            <BkpsCheckBox v-model="eventSchedule.checked" @input="$emit('changeCheckRow', $event)"/>
          </td>
          <td>{{ eventSchedule.id }}</td>
          <td>{{ eventSchedule.scheduleId || eventSchedule.schedule_id }}</td>
          <td>{{ eventSchedule.schedule.accountId || eventSchedule.schedule.account_id }}</td>
          <td>{{ getAccountNameAdapted(eventSchedule) }}</td>
          <td>{{ eventSchedule.schedule.appName || eventSchedule.schedule.app_name }}</td>
          <td>{{ eventSchedule.created_at || eventSchedule.createdAt | datetime }}</td>
          <td>{{ eventSchedule.updated_at || eventSchedule.updatedAt | datetime }}</td>
          <td>{{ eventSchedule.execute_in || eventSchedule.executeIn | datetime }}</td>
          <td>{{ eventSchedule.executed_at || eventSchedule.executedAt | datetime }}</td>
          <td>{{ eventSchedule.enable ? 'Sim' : 'Não' }}</td>
          <td>
            <span class="badge" :style="{ backgroundColor: `#${eventSchedule.color}` }">
              #{{ eventSchedule.color }}
            </span>
          </td>
          <td>{{ eventSchedule.created_by || eventSchedule.createdBy }}</td>
          <td>{{ eventSchedule.updated_by || eventSchedule.updatedBy }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import BkpsCheckBox from '@/components/shares/specialTag/BkpsCheckBox'

export default {
  components: { BkpsCheckBox },
  computed: {
    accountsLoaded() {
      return this.allAccounts && this.allAccounts.data && this.allAccounts.data.length > 0
    }
  },
  inject: ['allAccounts'],
  methods: {
    getAccountNameAdapted(eventSchedule) {
      const adaptedEntity = {
        accountId: eventSchedule.schedule?.accountId || eventSchedule.schedule?.account_id
      }
      this.accountsLoaded
      return this.getAccountName(adaptedEntity)
    }
  },
  name: 'Table',
  props: {
    checkAllRow: { required: true, type: Boolean },
    eventSchedules: { required: true, type: Array },
    getAccountName: { required: true, type: Function }
  }
}
</script>
